// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__3-qCO","footer":"ModalUpdate_footer__Mjpvt"};